<script setup lang="ts">
import { computed } from 'vue'
import type { Component } from 'vue'
// 专业线性图标库 (Lucide) —— 替换原手绘单 path SVG, 统一几何 / stroke, 去除"AI 自造 icon"感
import {
  Network, Route, Handshake, Layers, Send, Crown, Store, Users, UserCheck,
  ArrowRight, ArrowUp, Shield, Gauge, Fingerprint, Ruler, Clock, Bell, Download,
  Smartphone, Monitor, Wallet, Lock, Server, Code, Check, Mail, Phone, Globe,
  Eye, EyeOff, Signpost, CircleDollarSign, Headphones, Terminal, Map as MapIcon,
  CircleHelp,
} from 'lucide-vue-next'

const props = defineProps<{ name: string; size?: number }>()

// name → Lucide 组件映射 (保留原有全部调用名, 对外 API 不变)
const map: Record<string, Component> = {
  Network, Route, Handshake, Layers, Send, Crown, Store, Users, UserCheck,
  ArrowRight, ArrowUp, Shield, Gauge, Fingerprint, Ruler, Clock, Bell, Download,
  Smartphone, Monitor, Wallet, Lock, Server, Code, Check, Mail, Phone, Globe,
  Eye, EyeOff,
  // 就近映射: 无同名 Lucide 图标
  Route2: Signpost,
  Coin: CircleDollarSign,
  Headset: Headphones,
  Terminal,
  Map: MapIcon,
}

// 品牌专属自绘 (Lucide 无对应): ShieldChat=盾+对话, Telegram=品牌纸飞机
const custom: Record<string, { fill: boolean; path: string }> = {
  ShieldChat: { fill: false, path: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10zM8.5 11h7M8.5 14.5h4.5' },
  Telegram: { fill: true, path: 'M21.9 4.3 2.9 11.6c-1.1.4-1.1 1-.2 1.3l4.8 1.5 1.8 5.6c.2.6.4.7 1 .3l2.6-1.9 5 3.7c.9.5 1.6.2 1.8-.9l3.3-15.6c.3-1.3-.5-1.9-1.7-1.3zM7.9 14.4l10.6-6.7c.5-.3.9-.1.6.3l-9 8.1-.4 3.9z' },
}

const Comp = computed<Component | null>(() => map[props.name] || null)
const customPath = computed(() => custom[props.name] || null)
// 未命中: 回落 CircleHelp (便于发现遗漏), 而非静默用 Network
const isFallback = computed(() => !Comp.value && !customPath.value)
</script>

<template>
  <component
    v-if="Comp || isFallback"
    :is="Comp || CircleHelp"
    class="icon"
    :size="size"
    :stroke-width="1.7"
    aria-hidden="true"
  />
  <svg
    v-else
    class="icon"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="customPath!.fill ? 'currentColor' : 'none'"
    :stroke="customPath!.fill ? 'none' : 'currentColor'"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path :d="customPath!.path" />
  </svg>
</template>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
}
</style>
